<template>
  <div class="index-wrapper">
    <!-- <div style="width:100%;height:380px;background: url('../../../../static/img/erhida.jpg') no-repeat center;background-size: 100% 100%;">
      <div class="zhanwei" style="width:1240px;margin: 0 auto;text-align: right;padding: 34px 0;">
        <a style="display:inline-block;height:70px;padding-right:20px;" href="http://www.gov.cn/zhuanti/zggcddescqgdbdh/index.htm" target="_blank" class="dys_addLink">
          <img src="../../../../static/img/danghuiicon.png">
        </a>
      </div>
    </div> -->
    <div style="width:100%;">
        <a style="display:block;" href="https://m.mnr.gov.cn/zt/dj/xxgcd20d/" target="_blank" class="dys_addLink">
          <img style="width:100%;display: block;" src="../../../../static/img/zrzyb20d (1).png">
        </a>
    </div>
    <div class="index-banner" style="margin-top:0;">
      <!-- <div class="zhanwei" style="width:1240px;margin: 0 auto;text-align: right;padding: 14px 0;">
        <a style="display:inline-block;height:70px;padding-right:20px;" href="http://www.gov.cn/zhuanti/zggcddescqgdbdh/index.htm" target="_blank" class="dys_addLink">
          <img src="../../../../static/img/danghuiicon.png">
        </a>
      </div> -->
      <div class="index-banner-center">
        <div class="logo-wrapper">
          <div class="logo-left">
            <img src="/static/img/logo.png" alt>
          </div>
          <div class="logo-right">
            <div class="lr-img-box">
              <img src="/static/img/big-title.png" alt>
              <img class="logo-right-english" src="/static/img/small-title.png" alt>
            </div>
            <div class="lr-text-box">
              <img src="../../../../static/img/textlogo.png" alt="">
            </div>
            <div class="lang-switch">
              <span @click="langSwitch('E')" :class="languageActive==='E'?'languageActive':''">English</span>/
              <span @click="langSwitch('Z')" :class="languageActive==='Z'?'languageActive':''">中文</span>
            </div>
          </div>
        </div>
        <div class="nav-wrapper">
          <div class="nav-header">
            <div class="nav-item">
              <img src="/static/img/home-icon1.png" alt>
              <div class="text">首页</div>
            </div>
            <div class="nav-item">
              <img src="/static/img/home-icon2.png" alt>
              <div class="text">
                中心概况
                <i class="dia-sanjiao"></i>
              </div>
              <div class="hover-show">
                <div class="hover-show-item" @click="toPage({name:'centerIntro'})">中心简介</div>
                <div class="hover-show-item" @click="toPage({name:'centerMap'})">组织架构图</div>
                <div class="hover-show-item" @click="toPage({name:'centerCate'})">资质证书</div>
                <div class="hover-show-item" @click="toPage({name:'centerLeader'})">中心领导</div>
                <!-- <div class="hover-show-item" @click="toPage({name:'centerDuty'})">部门职责</div> -->
              </div>
            </div>
            <div class="nav-item" @click="toPage({name:'comPartyList',query:{section:section}})">
              <img src="/static/img/home-icon7.png" alt>
              <div class="text">党群建设</div>
            </div>
            <div class="nav-item">
              <img src="/static/img/home-icon3.png" alt>
              <div class="text">
                海洋标准化
                <i class="dia-sanjiao"></i>
              </div>
              <div class="hover-show">
                <!-- <div
                  class="hover-show-item"
                  @click="toPage({name:'BusinessIntro',query:{series:'1'}})"
                >计量检测
                  <br>实验室简介
                </div>-->
                <div
                  class="hover-show-item"
                  v-for="item in titleList[0]&&titleList[0].sub"
                  :key="item.id"
                  @click="toPage({name:'BusinessIntro',query:{type:1,firstId:item.id,workinfoId:item.sub[0]&&item.sub[0].id}})"
                >{{item.title}}</div>
                <!-- <div class="hover-show-item">标准化技术
                  <br>归口管理
                </div>
                <div class="hover-show-item">全国海洋标准化
                  <br>技术委员会
                </div>
                <div class="hover-show-item">国家计量认证
                  <br>海洋评审组
                </div>
                <div class="hover-show-item">全国海洋专业计量
                  <br>器具计量技术委员会
                </div>
                <div class="hover-show-item">质量监督
                  <br>管理
                </div>-->
              </div>
            </div>
            <div class="nav-item">
              <img src="/static/img/home-icon6.png" alt>
              <div class="text">
                海洋计量
                <i class="dia-sanjiao"></i>
              </div>
              <div class="hover-show">
                <div
                  class="hover-show-item"
                  v-for="item in titleList[2]&&titleList[2].sub"
                  :key="item.id"
                  @click="toPage({name:'BusinessIntro',query:{type:2,firstId:item.id,workinfoId:item.sub[0]&&item.sub[0].id}})"
                >{{item.title}}</div>
              </div>
            </div>
            <div class="nav-item">
              <img src="/static/img/home-icon8.png" alt>
              <div class="text">
                海洋质量监督
                <i class="dia-sanjiao"></i>
              </div>
              <div class="hover-show">
                <div
                  class="hover-show-item"
                  v-for="item in titleList[1]&&titleList[1].sub"
                  :key="item.id"
                  @click="toPage({name:'BusinessIntro',query:{type:3,firstId:item.id,workinfoId:item.sub[0]&&item.sub[0].id}})"
                >{{item.title}}</div>
              </div>
            </div>
            <div class="nav-item">
              <img src="/static/img/home-icon4.png" alt>
              <div class="text">
                科研与国际合作
                <i class="dia-sanjiao"></i>
              </div>
              <div class="hover-show">
                <div
                  class="hover-show-item"
                  @click="toPage({name:'CooperMajor', query: {
            showFlag: 0,
            type: 1
          }})"
                >重大专项</div>
                <div
                  class="hover-show-item"
                  @click="toPage({name:'CooperMajor', query: {
            showFlag: 1,
            type: 2
          }})"
                >国际合作</div>
                <div
                  class="hover-show-item"
                  @click="toPage({name:'CooperMajor', query: {
            showFlag: 2,
            type: 3
          }})"
                >科研项目管理</div>
              </div>
            </div>
            <div class="nav-item">
              <img src="/static/img/home-icon5.png" alt>
              <div class="text">
                人才队伍
                <i class="dia-sanjiao"></i>
              </div>
              <div class="hover-show">
                <!-- <div class="hover-show-item" @click="toPage({name:'education'})">教育培训</div> -->
                <!-- <div class="hover-show-item" @click="toPage({name:'demeanor'})">专家风采</div> -->
                <div class="hover-show-item" @click="toPage({name:'recruitment'})">人才招聘</div>
              </div>
            </div>
            <a href="#a01" class="nav-item">
              <img src="/static/img/home-icon9.png" alt>
              <div class="text">在线服务</div>
            </a>
          </div>
        </div>
        <div class="slide-wrapper">
          <div class="slide-wrapper-left">
            <div class="slide-box swiper-container swiper-style1">
              <ul class="swiper-wrapper">
                <li
                  class="swiper-slide swiper-no-swiping"
                  v-for="item in newsPicture"
                  :key="'new'+item.id"
                  @click="toPage({name:'NewsDetail',query:{newsFlag:1,id:item.id}})"
                >
                  <img class="banner-slide-one" :src="item.cover" alt>
                  <div class="banner-slide-text">{{item.title}}</div>
                </li>
              </ul>
              <div class="swiper-pagination"></div>
            </div>
          </div>
          <div class="slide-wrapper-right">
            <!-- 悬浮窗口 -->
            <div :class="floatList.length==2?'float-ad':'float-ad-lenght1'" v-if="toggleFloat">
              <!-- <div class="float-css-bg"> -->
              <div class="top-center">
                <div class="gg-title">
                  <div class="bgz-title">通知公告</div>
                </div>
                <div class="gg-list">
                  <div class="gg-list-item" v-for="item in floatList" :key="item.id">
                    <div class="float-title"><a href="javascript:;" style="color:#112854;" :title="item.title">{{item.title}}</a></div>
                    <div
                      class="float-more"
                      @click="toPage({name:'announceDetail',query:{annoceFlag:'2',id:item.id}})"
                    >了解更多></div>
                  </div>
                </div>
                <div class="close-float" @click="toggleFloat=false">关闭通告</div>
              </div>
              <!-- </div> -->

            </div>
            <!--<div class="slide-wrapper-right-nav">
              <div
                class="slide-wrapper-right-item"
                :class="{'slide-wrapper-right-item-active':newsFlag == 2}"
                @click="tabNews('2')"
              >部内要闻</div>
              <div
                class="slide-wrapper-right-item"
                :class="{'slide-wrapper-right-item-active':newsFlag == 3}"
                @click="tabNews('3')"
              >中心动态</div>
            </div>
            <div class="slide-wrapper-right-list">
              <ul>
                <li v-for="(item,index) in newList" :key="'news'+item.id">
                  <div
                    class="active-new-item"
                    v-if="item.link==''"
                    :class="{'top-new-item':(index<=0||item.new==1),'common-new-item':item.new ==0}"
                    @click="toPage({name:'NewsDetail',query:{newsFlag:newsFlag,id:item.id}})"
                  >{{item.title}}</div>
                  <a
                    v-else
                    class="fffcolor active-new-item"
                    :class="{'top-new-item':(index<=0||item.new==1),'common-new-item':item.new ==0}"
                    :href="item.link"
                    target="_blank"
                  >{{item.title}}</a>
                </li>
              </ul>
              <div class="more-out" @click="toPage({name:'NewsList',query:{newsFlag:'newsFlag'}})">
                <img src="/static/img/more-inner.png" alt>
              </div>
            </div>-->
            <div class="slide-wrapper-right-top">
              <div class="silder-r-top">
                <div class="slide-tab">
                  <h3>部内要闻</h3>
                </div>
                <div class="more-out" @click="toPage({name:'NewsList',query:{newsFlag:'2'}})">
                  MORE+
                </div>
              </div>
            	<span class="xian"></span>
            	<ul>
            		<li v-for="(item,index) in newList" :key="'news'+item.id">
                  <div
                    class="active-new-item"
                    v-if="item.link==''"
                    :class="{'top-new-item':(index<=0||item.new==1),'common-new-item':item.new ==0}"
                    @click="toPage({name:'NewsDetail',query:{newsFlag:'2',id:item.id}})"
                  >{{item.title}}</div>
                  <a
                    v-else
                    class="fffcolor active-new-item"
                    :class="{'top-new-item':(index<=0||item.new==1),'common-new-item':item.new ==0}"
                    :href="item.link"
                    target="_blank"
                    :title='item.title'
                  >{{item.title}}</a>
                  <span class="time">{{item.add_time | parseTime('{y}-{m}-{d}')}}</span>
                </li>
            	</ul>
            </div>
            <div class="slide-wrapper-right-foot">
              <div class="silder-r-top">
                <div class="slide-tab">
                  <h3 @click="getCenterNewList('3')" :class="tabActive==='3'?'tabActive':''">中心动态</h3>
                  <!-- <h3 @click="getCenterNewList('5')" :class="tabActive==='5'?'tabActive':''" style="width:166px;font-size:18px;">30周年系列活动</h3> -->
                </div>
                <div class="more-out" @click="toPage({name:'NewsList',query:{newsFlag:tabActive}})">
                  MORE+
                </div>
              </div>
            	<span class="xian"></span>
            	<ul>
            		<li v-for="(item,index) in centerNewList" :key="'news'+item.id">
                  <div
                    class="active-new-item"
                    v-if="item.link==''"
                    :class="{'top-new-item':(index<=0||item.new==1),'common-new-item':item.new ==0}"
                    @click="toPage({name:'NewsDetail',query:{newsFlag:tabActive,id:item.id}})"
                  >
                  <a href="javascript:;" style="color: #fff;"  :title='item.title'>
                    {{item.title}}</a>
                  </div>
                  <a
                    v-else
                    class="fffcolor active-new-item"
                    :class="{'top-new-item':(index<=0||item.new==1),'common-new-item':item.new ==0}"
                    :href="item.link"
                    target="_blank"
                    :title='item.title'
                  >{{item.title}}</a>
                  <span class="time">{{item.add_time | parseTime('{y}-{m}-{d}')}}</span>
                </li>
            	</ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="banner-line">
      <div class="banner-line-grey">
        <div class="banner-sanjiao"></div>
      </div>
    </div>
    <div class="index-section2">
      <!-- <a
        v-if="partyactivety.url && partyactivety.url!=''"
        target="_blank"
        class="index-section2-top"
        :href="partyactivety.url"
      >
        <img :src="partyactivety.cover" alt>
      </a>
      <div
        v-else
        class="index-section2-top"
        @click="toPage({name:'comPartyDetail',query:{id:partyactivety.id,section:2}})"
      >
        <img :src="partyactivety.cover" alt>
      </div> -->
      <div class="index-section2-top" @click="toPage({name:'partyBuilding'})"><img :src="partyactivety.cover" alt></div>
      <div class="index-section-new">
        <div class="index-section-new-left">
          <div class="index-section-new-left-title">
            <div :class="{'active':section == '2'}" @click="getPatry('2')">党建动态</div>
            <div :class="{'active':section == '3'}" @click="getPatry('3')">党风廉政</div>
            <div :class="{'active':section == '4'}" @click="getPatry('4')">群团建设</div>
            <div :class="{'active':section == '5'}" @click="getPatry('5')">期刊</div>
          </div>
          <ul class="section2-list">
            <li
              v-for="(item,index) in partyList"
              :key="'party'+item.id"
              class="active-new-item"
              :class="{'top-section2-item':(index<1||item.new==1),'common-section2-item':item.new ==0}"
              @click="toPage({name:'comPartyDetail',query:{id:item.id,section:section}})"
            >
            	<div class="section2-list-content"><a href="javascript:;" style="color: #2a2a2a;" :title="item.title">{{item.title}}</a></div>
            	<span>{{item.add_time | parseTime('{y}-{m}-{d}')}}</span>
            </li>
          </ul>
          <div class="add-more1" @click="toPage({name:'comPartyList',query:{section:section}})"></div>
        </div>
        <div class="index-section-new-right">
          <div class="slide-box swiper-container swiper-style3">
            <ul class="swiper-wrapper">
              <li
                class="swiper-slide swiper-no-swiping"
                v-for="item in partyPicture"
                :key="'pic'+item.id"
                @click="toPage({name:'comPartyDetail',query:{id:item.id,section:5}})"
              >
                <img class="section-img" :src="item.cover" alt>
                <div class="section-text">{{item.title}}</div>
              </li>
            </ul>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="section3">
      <div class="section3-cener">
        <div class="section3-cener-left">
          <div class="slide-box swiper-container swiper-style2">
            <ul class="swiper-wrapper">
              <!-- <li class="swiper-slide swiper-no-swiping" v-for="item in activityList" :key="'_'+item.id" >
                <div class="sw-wrapper">
                  <video :src="item.video" poster="/static/img/test.png" class="section2-img"></video>
                  <div
                    class="section3-text"
                    @click="toPage({name:'announceDetail',query:{annoceFlag:'2',id:item.id}})"
                  >{{item.title}}</div>
                </div>
              </li>-->
              <li class="swiper-slide swiper-no-swiping" v-for="i in activityList" :key="i.id">
                <div class="sw-wrapper">
                  <img :src="i.cover" class="section2-img" alt>
                  <!-- <video :ref="'video'+i.id" :src="i.video" :poster="i.cover" class="section2-img"></video> -->
                  <div class="play-btn" v-show="i.videoflag == 'true'" @click="playVideo(i.id,i.video)"></div>
                  <!-- <div class="play-full-puse" v-show="!videoFlag">
                    <div class="control" :ref="'control'+i.id">
                      <div id="progress" :ref="'progress'+i.id"></div>

                      <div id="scroll" @mousedown="mouseDo($event,i.id)" :ref="'scroll'+i.id"></div>
                    </div>
                    <i @click="pauseVideo(i.id,i.video)" class="iconfont">&#xe635;</i>
                    <i @click="fullVideo(i.id,i.video)" class="iconfont">&#xe758;</i>
                  </div>-->
                  <div

                    class="section3-text"
                    @click="toPage({name:'announceDetail',query:{annoceFlag:'1',id:i.id}})"
                  >{{i.title}}</div>
                </div>
              </li>
            </ul>
            <div v-show="videoFlag" class="swiper-pagination my-pagination-clickable"></div>
          </div>
        </div>
        <div class="section3-cener-right">
          <div class="section3-cener-right-title">通知公告</div>

          <ul class="section3-list">
            <li
              v-for="(item,index) in noticeList"
              :key="'annouce'+item.id"
              class="active-new-item"
              :class="{'top-section3-item':(index<=0||item.new==1),'common-section3-item':item.new ==0}"
              @click="toPage({name:'announceDetail',query:{annoceFlag:'2',id:item.id}})"
            >
            	<div class="section3-list-content">
            		<a href="javascript:;" style="color: #2a2a2a;" :title="item.title">{{item.title}}</a>
            	</div>
            	<span>{{item.add_time | parseTime('{y}-{m}-{d}')}}</span>
            </li>
          </ul>
          <div class="add-more2" @click="toPage({name:'announceList',query:{annoceFlag:'2'}})"></div>
        </div>
      </div>
    </div>
    <div class="section4" id='a01'>
      <div class="section4-img-wrapper">
        <img src="/static/img/NCOSM.png" alt>
        <img src="/static/img/zxfwpt.png" alt>
        <div class="section4-line"></div>
        <!-- <div class="section4-center">
          <a class="section4-center-item section4-center-item1" href="http://www.ncosm.org.cn/ncosm/portal/index" target="_blank">
              <div class="section4-center-item-text">最新海洋标准信息发布、标准制修订管理</div>
             </a>
          <a class="section4-center-item section4-center-item2" href="http://www.ncosm.org.cn/#/businesss/detail?firstId=7&workinfoId=9&id=9&type=2" target="_blank">
            <div class="section4-center-item-text">海洋仪器检测服务，标准海水购买服务</div>
          </a> -->
          <!-- <div
            class="section4-center-item section4-center-item2"
            @click="toPage({name:'BusinessDetail',query:{type:2,firstId:7,workinfoId:9,id:9}})"
          >
            <div class="section4-center-item-text">海洋仪器检测服务，标准海水购买服务</div>
          </div> -->
          <!-- <a href="http://www.ncosm.org.cn:8099/SubPlat" target="_blank" class="section4-center-item section4-center-item3">
              <div class="section4-center-item-text">大型仪器开放共享服务</div>
            </a>
          <div
            class="section4-center-item section4-center-item4"
            @click="toPage({name:'multipleinfo',query:{type:2}})"
          >
            <div class="section4-center-item-text">质量管理信息填报服务</div>
          </div>
          <div
            class="section4-center-item section4-center-item5"
          >
            <a href="http://baoming.ncosm.org.cn/#/" style="width:100%;height: 100%;display: block;"><div class="section4-center-item-text">在线报名系统</div></a>
          </div>
          <div style="clear:both;"></div>
        </div> -->
        <div class="section4-new">
          <div class="list">
            <a href="http://www.ncosm.org.cn/ncosm/portal/index" target="_blank">
              <div class="listImg"></div>
              <p class="title">标准化信息系统</p>
              <p class="tip">最新海洋标准信息发布</p>
              <p class="tip">标准制修订管理</p>
              <p class="look">点击查看</p>
            </a>
          </div>

          <div class="list">
            <a href="javascript:;" @click="toPage({name:'linkPage'})">
            <div class="listImg"></div>
            <p class="title">团体标准管理系统</p>
            <p class="tip"></p>
            <p class="tip"></p>
            <p class="look">点击查看</p>
          </a>
          </div>

          <div class="list">
            <a href="http://www.ncosm.org.cn/#/businesss/detail?firstId=7&workinfoId=9&id=9&type=2" target="_blank">
            <div class="listImg"></div>
            <p class="title">计量检测委托业务</p>
            <p class="tip">海洋仪器检测服务</p>
            <p class="tip">标准海水购买服务</p>
            <p class="look">点击查看</p>
          </a>
          </div>

          <div class="list">
            <a href="https://zrzynlkh.sealyyg.com/" target="_blank">
            <div class="listImg"></div>
            <p class="title">自然资源检验检测能力</p>
            <p class="title">考核工作平台</p>
            <p class="look">点击查看</p>
            </a>
          </div>

          <div class="list">
            <a href="http://baoming.ncosm.org.cn/#/" target="_blank">
            <div class="listImg"></div>
            <p class="title">活动报名</p>
            <p class="tip">在线报名系统</p>
            <p class="look">点击查看</p>
            </a>
          </div>

          <div class="list">
            <a href="http://www.ncosm.org.cn:8099/SubPlat" target="_blank">
            <div class="listImg"></div>
            <p class="title">大型仪器设备共享平台</p>
            <p class="tip">大型仪器开放共享服务</p>
            <p class="look">点击查看</p>
            </a>
          </div>

          <div class="list">
            <a href="javascript:;" @click="toPage({name:'multipleinfo',query:{type:2}})">
            <div class="listImg"></div>
            <p class="title">质量管理信息填报</p>
            <p class="tip">质量管理信息填报服务</p>
            <p class="look">点击查看</p>
            </a>
          </div>

          <div class="list">
            <a href="http://120.53.4.73/#/home/index" target="_blank">
            <div class="listImg"></div>
            <p class="title">海洋国家级检验检测机构</p>
            <p class="title">资质认定管理系统</p>
            <p class="look">点击查看</p>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="section5">
      <a href="http://mail.ncosm.org.cn/">
        <img class="section5-img" src="/static/img/login.png" alt>
      </a>
      <div class="secton5-right">
        <div class="section5-shadow">
          <div class="section5-right-top">
            <div class="section5-top-text">
              <img class="link-icon" src="/static/img/link.png" alt>
              <span class="link-text">友情链接</span>
            </div>
          </div>
          <div class="section5-select">
            <div class="select-item" v-for="(item,index) in friendLinkList" :key="item.id">
              <i class="icon-down lMar10"></i>
              <select name id v-model="item.linkUrl" @change="switchUrl(item.linkUrl)">
                <option value v-if="index==0">国家部委</option>
                <option value v-else-if="index==1">部属单位</option>
                <option value v-else-if="index==2">相关单位</option>
                <option value v-else>国际组织</option>
                <option :value="child.url" v-for="child in item" :key="child.id">{{child.name}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="video-fixed" v-if="videoSrc" @click="videoSrc =''">
      <div class="close-video" @click.stop="videoSrc=''">
        <img src="/static/img/close.png" alt>
      </div>
      <video class="fixed-video-width" ref="videoRef" controls="controls" :src="videoSrc"></video>
    </div>
  </div>
</template>

<script type="text/javascript">var cnzz_protocol = (("https:" == document.location.protocol) ? "https://" : "http://");document.write(unescape("%3Cspan id='cnzz_stat_icon_1277843947'%3E%3C/span%3E%3Cscript src='" + cnzz_protocol + "s23.cnzz.com/z_stat.php%3Fid%3D1277843947%26show%3Dpic1' type='text/javascript'%3E%3C/script%3E"));</script>

<script>
import Vue from "vue";
import "../../../../static/css/swiper-4.1.0.min.css";
import Swiper from "../../../../static/js/swiper-4.1.0.min.js";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      floatList: [],
      toggleFloat: false,
      videoFlag: true,
      swiper2: "",
      newsFlag: "2",
      section: "2",
      noticeList: [], //重要公告列表
      activityList: [], //重要活动列表
      newList: [],
      centerNewList:[],
      partyList: [],
      partyPicture: [],
      newsPicture: [],
      partyactivety: [],
      time: 0,
      video_length: 0,
      titleList: [],
      friendLinkList: [],
      videoSrc: "",
      languageActive: "Z",  //当前使用语言
      tabActive: '3',   //新闻tab
    };
  },
  mounted() {
    this.getFloatList();
    this.getBusinessList();
    this.swiperDom3();
    this.swiperDom();
    this.getNoticeList(1);
    this.getNoticeList(2);
    this.getNewList();
    this.getPatry(2);
    this.getPatryPicture();
    this.getNewPicture();
    this.getPatryactivety();
    this.getFriendLink();
    this.getCenterNewList('3');
    this.$nextTick(()=>{
      if(this.$route.query.fr == 'zxfw'){
        location.href = '#a01';
      }
    })
  },
  // 最上部新闻的轮播
  methods: {
    ts(){
      alert('暂未开放');
    },
    //切换语言逻辑
    langSwitch(type){
      return;  //暂不开放
      this.languageActive = type;
    },
    getFloatList() {
      userApi.getFloatList().then(res => {
        if(res.data.list.length>=2){
          this.floatList = res.data.list.slice(0,2);
        }else{
          this.floatList = res.data.list;
        }
        if (this.floatList.length > 0) {
          this.toggleFloat = true;
        } else {
          this.toggleFloat = false;
        }
      });
    },
    getBusinessList() {
      userApi.worksperiod().then(res => {
        this.titleList = res.data;
      });
    },
    swiperDom() {
      var swiper = new Swiper(".swiper-style1", {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        loop: false,
        paginationClickable: true,
        slideToClickedSlide: true,
        preventLinksPropagation: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        }
      });
    },
    // 中间党建的轮播
    swiperDom3() {
      var swiper = new Swiper(".swiper-style3", {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        loop: false,
        paginationClickable: true,
        slideToClickedSlide: true,
        preventLinksPropagation: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        }
      });
    },
    //重要活动
    swiperDom2() {
      this.swiper2 = new Swiper(".swiper-style2", {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function(index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          }
        },
        loop: false,
        // paginationClickable: true,
        // slideToClickedSlide: true,
        // preventLinksPropagation: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        }
      });
    },
    //获取活动 通告列表
    getNoticeList(idx) {
      let _this = this;
      userApi.getNoticeList({ type: idx, page: 1, count: 6 }).then(res => {
        if (idx == 1) {
          _this.activityList = res.data.list;
        } else {
          _this.noticeList = res.data.list;
        }
        Vue.nextTick().then(function() {
          setTimeout(() => {
            _this.swiperDom2();
          }, 1000);
        });
      });
    },
    // 获取新闻的首页列表文章类型，1推荐新闻，2部内要闻，3中心要闻，4活动新闻
    getNewList() {
      const params = {
        type: '2',
        page: 1,
        count: 3
      };
      userApi.getnewList(params).then(res => {
        this.newList = res.data.list.slice(0,2);
      });
    },
    getCenterNewList(type) {
      this.tabActive = type;
      const params = {
        type: type,
        page: 1,
        count: 5
      };
      userApi.getnewList(params).then(res => {
        this.centerNewList = res.data.list.slice(0,3);
        //console.log(this.newList)
      });
    },
    //获取新闻的轮播 最上面
    getNewPicture() {
      let _this = this;
      const params = {
        type: 1,
        page: 1,
        count: 4
      };
      userApi.getnewList(params).then(res => {
        _this.newsPicture = res.data.list;
        Vue.nextTick().then(function() {
          setTimeout(() => {
            _this.swiperDom();
          }, 1000);
        });
      });
    },

    //获取1专题活动
    getPatryactivety() {
      const params = {
        type: 1,
        page: 1,
        count: 1
      };
      userApi.getpartyList(params).then(res => {
        this.partyactivety = res.data.list[0];
      });
    },
    // 获取党建的列表，2党建动态，3党风廉政，4群团建设，5图片新闻
    getPatry(val) {
      if(val === '5' ){
        this.$router.push({name:'JournalList'});
        return;
      }
      this.section = val;
      const params = {
        type: this.section,
        page: 1,
        count: 6
      };
      userApi.getpartyList(params).then(res => {
        this.partyList = res.data.list;
      });
    },
    //获取图片党建轮播
    getPatryPicture() {
      let _this = this;
      const params = {
        type: 5,
        page: 1,
        count: 5
      };
      userApi.getpartyList(params).then(res => {
        this.partyPicture = res.data.list;
        Vue.nextTick().then(function() {
          setTimeout(() => {
            _this.swiperDom3();
          }, 1000);
        });
      });
    },
    //获取友情链接列表
    getFriendLink() {
      let _this = this;
      userApi.getFriendLink("").then(res => {
        Object.keys(res.data).forEach(item => {
          _this.friendLinkList.push(res.data[item]);
        });
        for (var i = 0; i < _this.friendLinkList.length; i++) {
          _this.friendLinkList[i].linkUrl = "";
        }
      });
    },
    // 友情链接选中跳转
    switchUrl(vals) {
      if (vals != "") {
        window.open(vals);
      }
    },
    tabNews(flag) {
      // 获取首页新闻的列表
      this.newsFlag = flag;
      this.getNewList();
    },
    toPage(url) {
      if(url.name === "BusinessIntro"&&url.query.type === 1){
        //跳转指定外链
        if(url.query.firstId==='41'){
          window.open('http://www.ncosm.org.cn/ncosm/portal/index#page4')
        }else if(url.query.firstId==='4'){
          window.open('http://www.ncosm.org.cn/ncosm/portal/index')
        }else if(url.query.firstId==='44'){
          window.open('http://www.ncosm.org.cn/#/linkPage')
        }{
          this.$router.push(url);
        }
      }else{
        this.$router.push(url);
      }
    },
    playVideo(i, src) {
      var _this = this;
      _this.videoSrc = src;
      setTimeout(() => {
        var video = _this.$refs["videoRef"];
        video.play();
        video.addEventListener(
          "ended",
          function() {
            // _this.videoSrc = "";
          },
          false
        );
      }, 100);
      // let _this = this;
      // _this.videoFlag = false;
      // // for(var j=0;j<2;j++) {
      // //   this.$refs['video'+j][0].pause();
      // // }
      // var video = this.$refs["video" + i][0];
      // _this.video_length = video.duration;
      // video.play();
      // video.addEventListener(
      //   "ended",
      //   function() {
      //     _this.src = src;
      //     _this.videoFlag = true;
      //     _this.swiperDom2();
      //   },
      //   false
      // );
      // video.addEventListener(
      //   "timeupdate",
      //   function() {
      //     var control = _this.$refs["control" + i][0];
      //     var progress = _this.$refs["progress" + i][0];
      //     var scroll = _this.$refs["scroll" + i][0];
      //     //获取当前视频播放的位置
      //     var time = video.currentTime;
      //     //获取当前视频总的视频长度
      //     var video_length = video.duration;

      //     var scales = time / video_length;

      //     progress.style.width = scales * control.offsetWidth + "px";

      //     //obj.style.width只能够设置宽度，想要获取宽度只能够用offsetWidth

      //     scroll.style.left =
      //       scales * (control.offsetWidth - scroll.offsetWidth) + "px";
      //   },
      //   false
      // );
    },
    mouseDo(e, i) {
      let _this = this;
      var video = this.$refs["video" + i][0];
      video.pause();
      var control = _this.$refs["control" + i][0];
      var progress = _this.$refs["progress" + i][0];
      var scroll = _this.$refs["scroll" + i][0];
      var menu = document.getElementsByClassName("section3-cener")[0];
      document.onmousemove = function(e) {
        var leftx = e.clientX - menu.offsetLeft - control.offsetLeft;
        if (leftx <= 0) {
          leftx = 0;
        }
        if (leftx >= control.offsetWidth) {
          leftx = control.offsetWidth;
        }
        progress.style.width = leftx + "px";
        scroll.style.left = leftx + "px";
      };

      document.onmouseup = function() {
        var scales = scroll.offsetLeft / control.offsetWidth;
        var nowatime = scales * video.duration;
        video.currentTime = nowatime;
        video.play();
        document.onmouseup = null;
        document.onmousemove = null;
      };
    },
    pauseVideo(i, src) {
      let _this = this;
      _this.videoFlag = true;
      var video = this.$refs["video" + i][0];
      video.pause();
    },
    fullVideo(i, src) {
      var _hei = document.documentElement.scrollTop || document.body.scrollTop;
      let _this = this;
      var video = this.$refs["video" + i][0];
      if (video.requestFullscreen) {
        video.requestFullscreen();
        document.body.scrollTop = _hei + "px";
        // document.documentElement.scrollTop = _hei + "px";
      } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen();
        document.body.scrollTop = _hei + "px";
        // document.documentElement.scrollTop = _hei + "px";
      } else if (video.webkitRequestFullScreen) {
        video.webkitRequestFullScreen();
        document.body.scrollTop = _hei + "px";
        // document.documentElement.scrollTop = _hei + "px";
      }
    }
    //   pauseSlide(){
    //   this.swiper2.autoplay.stop();
    // },
    //   startSlide(){
    //   this.swiper2.autoplay.start();
    // }
  },
  watch: {
    time(val, oldval) {
    }
  }
};
</script>
<style scoped>
.index-wrapper {
  width: 100%;
}
.index-banner {
  width: 100%;
  height: 800px;
  background-image: url(/static/img/banner.png);
  background-size: 100% 100%;
  position: relative;
  margin-top: -200px;
}
.banner-line {
  width: 100%;
  height: 136px;
  background: url(/static/img/top-line.png) no-repeat center 68px;
  background-size: 2560px 40px;
  position: relative;
  margin-top: -100px;
}
.banner-line-grey {
  width: 100%;
  height: 3px;
  background: #b2b9c3;
  position: absolute;
  top: 100px;
  left: 0;
}
.banner-sanjiao {
  position: absolute;
  width: 860px;
  height: 34px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background: url(/static/img/sanjiao.png) no-repeat center right;
  background-size: 40px 34px;
}
.index-banner-center {
  width: 1240px;
  margin: 0 auto;
  padding: 40px 0 0 0;
}
.logo-wrapper {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.logo-left {
  margin-right: 40px;
}
.logo-left img{
  width: 104px;
}
.logo-right{
  display: flex;
  /* align-items: flex-end; */
  justify-content: space-between;
}
.lr-img-box{
  width:555px;
}
.lr-text-box{
  width:308px;
  margin-left: 55px;
  margin-top: 20px;
}
.lr-text-box img{
  width:308px;
  height: 68px;
  display: block;
}
.logo-right .lr-img-box img{
  width: 555px;
}
.lang-switch{
  width: 195px;
  text-align: right;
  color: white;
  font-size: 20px;
  color: #71A7E8;
}
.lang-switch span{
  cursor: pointer;
}
.languageActive{
  color: #fff;
}
.logo-right-english {
  margin-top: 11px;
}
.nav-wrapper {
  margin-top: 40px;
}
.nav-header {
  width: 100%;
  height: 118px;
  background: url(/static/img/nav-bj.png) no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: nowrap;
  position: relative;
}
.nav-item {
  flex: 1;
  height: 100%;
  text-align: center;
  padding: 19px 0;
  box-sizing: border-box;
  cursor: pointer;
}
.hover-show {
  position: absolute;
  top: 118px;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 25px 30px;
  box-sizing: border-box;
  display: none;
  overflow: hidden;
  z-index: 100;
}
.hover-show-item::after {
  position: absolute;
  content: " ";
  left: 0;
  top: 0;
  width: 8px;
  height: 100%;
}
.hover-show-item {
  font-size: 18px;
  line-height: 30px;
  padding: 5px 0;
  box-sizing: border-box;
  border-left: 8px solid #b9c4dd;
  color: #b9c4dd;
  float: left;
  margin-right: 40px;
  position: relative;
  padding-left: 10px;
  cursor: pointer;
  text-align: left;
  margin-bottom: 10px;
}
.hover-show-item:hover {
  border-left: 8px solid #265add;
  color: #265add;
}
.nav-item:hover {
  background: #085ccb;
}
.nav-item:hover .hover-show {
  display: block;
}
.nav-item:hover .dia-sanjiao {
  display: block;
}
.nav-item img {
  height: 40px;
  display: inline-block;
  margin: 0 auto;
}
.nav-item .text {
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  position: relative;
}
.dia-sanjiao {
  display: none;
  width: 0;
  height: 0;
  border-width: 0 10px 10px;
  border-style: solid;
  border-color: transparent transparent #fff; /*透明 透明  黄*/
  position: absolute;
  bottom: -18px;
  left: 50%;
  transform: translateX(-50%);
}
.slide-wrapper {
  display: flex;
  height: 432px;
}
.slide-wrapper-left {
  width: 731px;
  height: 100%;
  box-sizing: border-box;
  background: #fff;
}
.slide-wrapper-right {
  width: 509px;
  height: 100%;
  background: url(/static/img/banner-right-bj.png) no-repeat center;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
}
/*新增悬浮窗口样式*/
.float-ad {
  position: fixed;
  width: 257px;
  height: 338px;
  bottom: 44px;
  right: 30px;
  background: url(/static/img/top-3.png) no-repeat center center;
  background-size: 257px 338px;
  padding: 38px 30px 0 33px;
  box-sizing: border-box;
  z-index: 111;
}
.float-ad-lenght1 {
  position: fixed;
  width: 257px;
  height: 246px;
  bottom: 200px;
  right:0;
  background: url(/static/img/top-4.png) no-repeat center center;
  background-size: 257px 246px;
  padding: 37px 30px 0 30px;
  box-sizing: border-box;
  z-index: 111;
}
/* .float-ad::after {
  content: "";
  position: absolute;
font-size: 0;
line-height: 0;
border-width: 13px;
border-color: rgba(255, 255, 255, 0.5);
border-right-width: 0;
border-style: dashed;
border-left-style: solid;
border-top-color: transparent;
border-bottom-color: transparent;
right: 21px;
bottom: 15px;

} */
/* .float-css-bg{
  width: 190px;
  padding:10px;
  box-sizing: border-box;
  height: 100%;
  background:rgba(255, 255, 255, 0.5);
  position: relative;
  border-radius: 5px;
  -webkit-border-radius:5px;
} */
.top-center {
  width: 174px;
  margin: 0 auto;
}
.gg-title {
  margin-top: -2px;
  width: 100%;
  height: 60px;
  background: #fff;
  position: relative;
  border-radius: 5px 5px 0 0;
}
.bgz-title {
  width: 229px;
  height: 60px;
  position: absolute;
  top: 0px;
  left: -29px;
  background: url(/static/img/top-1.png) no-repeat center center;
  background-size: 229px 60px;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  font-size: 20px;
}
.gg-list {
  margin-top: -16px;
}
.gg-list-item {
  background: #fff;
  margin-bottom: 8px;
  padding: 14px 17px;
  box-sizing: border-box;
}
.float-title {
  width: 100%;
  font-size: 14px;
  color: #112854;
  line-height: 16px;
  height: 32px;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.float-more {
  margin-top: 9px;
  margin-bottom: 0px;
  text-align: right;
  font-size: 12px;
  color: #112854;
  cursor: pointer;
}
.close-float {
  width: 174px;
  height: 34px;
  background: url(/static/img/top-2.png) no-repeat center center;
  background-size: 100% 100%;
  line-height: 34px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}
/*新增悬浮窗口样式*/
.add-more1 {
  width: 80px;
  height: 30px;
  background: url(/static/img/add-more1.png) no-repeat center center;
  background-size: 100% 100%;
  margin-left: 53px;
  box-sizing: border-box;
  cursor: pointer;
}
.add-more2 {
  margin-top: 25px;
  cursor: pointer;
  width: 80px;
  height: 30px;
  background: url(/static/img/add-more2.png) no-repeat center center;
  background-size: 100% 100%;
  margin-left: 28px;
  box-sizing: border-box;
}
.banner-slide-one {
  width: 100%;
  height: 432px;
}
.banner-slide-text {
  font-size: 22px;
  color: #fff;
  padding-right: 100px;
  line-height: 93px;
  padding-left: 26px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #000;
  opacity: 0.7;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.swiper-pagination{
  bottom: 40px;
  right: 0;
  text-align: right;
  padding-right: 39px;
  box-sizing: border-box;
}
/*.slide-wrapper-right-nav {
  display: flex;
}
.slide-wrapper-right-item {
  width: 50%;
  font-size: 20px;
  text-align: center;
  line-height: 60px;
  color: #0c5ebb;
  cursor: pointer;
  border-bottom: 1px solid #194eb0;
}
.slide-wrapper-right-item-active {
  background: #194eb0;
  color: #fff;
}
.slide-wrapper-right-list {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}
.slide-wrapper-right-list ul {
  height: 420px;
}
.slide-wrapper-right-list li {
  width: 100%;
  line-height: 42px;
  font-size: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #fff;
  cursor: pointer;
  position: relative;
  padding-left: 28px;
  box-sizing: border-box;
}
.top-new-item::after {
  position: absolute;
  top: 12px;
  left: 0;
  content: "";
  background: url(/static/img/newicon.png) no-repeat center;
  background-size: 100% 100%;
  width: 21px;
  height: 21px;
}
.common-new-item::after {
  position: absolute;
  top: 16px;
  left: 5px;
  content: " ";
  background: #fff;
  width: 12px;
  height: 12px;
  border-radius: 10px;
}
.fffcolor {
  color: #fff !important;
}
.active-new-item:hover {
  text-decoration: underline;
}*/
.slide-wrapper-right-top,.slide-wrapper-right-foot{
	width:100%;
	margin-left:5px;
}
.slide-wrapper-right-top{
	margin-bottom: 20px;
	margin-top: 29px;;
}
.slide-wrapper-right-top .silder-r-top h3{
	width:143px;
	padding:0 0 17px 0;
	color: #fff;
	display: block;
	text-align: center;
	letter-spacing: 2px;
	border-bottom:4px solid #FFFFFF ;
}
.slide-wrapper-right-top .xian{
	width:466px;
	height:1px;
	display:block;
	background: #fff;
}
.slide-wrapper-right-top li {
  width: 100%;
  line-height: 42px;
  font-size: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #fff;
  cursor: pointer;
  position: relative;
  padding-left: 28px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.slide-wrapper-right-top li:first-of-type{
  margin-top: 10px;
}
.slide-wrapper-right-top li  a{
  color: #fff;
}
.slide-wrapper-right-top .active-new-item,
.slide-wrapper-right-top a{
	width:65%;
	text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.slide-wrapper-right-top .time{
	margin-right: 40px;
	font-size: 14px;
}
.slide-wrapper-right-foot .silder-r-top h3{
	width:148px;
	padding:17px 0;
	display: block;
	text-align: center;
	letter-spacing: 2px;
  color: #BDE5FD;
  cursor: pointer;
}
.slide-wrapper-right-foot .silder-r-top .slide-tab{
  display: flex;
}
.slide-wrapper-right-foot .silder-r-top .slide-tab .tabActive{
  border-bottom: 4px solid #03399D;
  color: #fff;
}
.slide-wrapper-right-foot .xian{
	width:466px;
	height:1px;
	background: #194EB0;
	display: block;
}
.slide-wrapper-right-foot li {
  width: 100%;
  line-height: 42px;
  font-size: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #fff;
  cursor: pointer;
  position: relative;
  padding-left: 28px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.slide-wrapper-right-foot li:first-of-type{
  margin-top: 10px;
}
.slide-wrapper-right-foot .active-new-item,
.slide-wrapper-right-foot a{
	width:65%;
	text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.slide-wrapper-right-foot .time{
	margin-right: 40px;
	font-size: 14px;
}
.top-new-item::after {
  position: absolute;
  top: 12px;
  left: 0;
  content: "";
  background: url(/static/img/newicon.png) no-repeat center;
  background-size: 100% 100%;
  width: 21px;
  height: 21px;
}
.common-new-item::after {
  position: absolute;
  top: 16px;
  left: 5px;
  content: " ";
  background: #fff;
  width: 12px;
  height: 12px;
  border-radius: 10px;
}

.silder-r-top{
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.more-out {
  font-size: 12px;
  color: white;
  overflow: hidden;
  cursor: pointer;
  margin: 0 40px 15px 0;
}
.slide-wrapper-left /deep/ .swiper-pagination-bullet {
  background: #fff;
  opacity: 1 !important;
}
.slide-wrapper-left /deep/ .swiper-pagination-bullet-active {
  background: #194eb0;
}
.index-section2 {
  width: 1240px;
  margin: 31px auto 0;
}
.index-section2-top {
  display: block;
  width: 1236px;
  height: 120px;
  /* background: url(/static/img/xuexi1.png) no-repeat center center;
  background-size: 100% 100%; */
  margin-bottom: 50px;
  cursor: pointer;
}
.index-section2-top > img {
  width: 100%;
  height: 100%;
}
.index-section-new {
  width: 100%;
  height: 440px;
  display: flex;
  position: relative;
}
.index-section-new::after {
  width: 100%;
  height: 45px;
  content: " ";
  position: absolute;
  background: url(/static/img/shadow1.png) no-repeat center;
  background-size: 100% 100%;
  bottom: -45px;
  left: 0;
}
.index-section-new-left {
  width: 620px;
  height: 100%;
  border: 1px solid #ddd;
  border-right: none;
  box-sizing: border-box;
}
.index-section-new-left-title {
  width: 100%;
  height: 60px;
  color: #ef2911;
  font-size: 20px;
  background: #e3e8ef;
  padding-left: 32px;
  box-sizing: border-box;
}
.index-section-new-left-title > div {
  margin: -5px 0;
  width: 120px;
  height: 70px;
  line-height: 70px;
  float: left;
  text-align: center;
  cursor: pointer;
}
.index-section-new-left-title > div.active {
  background: #ea503a;
  color: #fff;
}
.index-section-new-right {
  width: 620px;
  height: 100%;
  border: 1px solid #ddd;
  padding: 10px;
  box-sizing: border-box;
}
.index-section-new-right > .swiper-container li {
  width: 600px;
  height: 100%;
  position: relative;
}
.section2-list {
  padding: 25px 40px 25px 25px;
  box-sizing: border-box;
}
.section2-list li {
	display: flex;
	justify-content: space-between;
  width: 100%;
  line-height: 42px;
  font-size: 16px;
  color: #2a2a2a;
  cursor: pointer;
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  box-sizing: border-box;
}
.section2-list .section2-list-content{
	width: 70%;
	text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.section2-list li span{
	font-size: 14px;
}
.top-section2-item::after {
  position: absolute;
  top: 12px;
  left: 0;
  content: "";
  background: url(/static/img/newicon.png) no-repeat center;
  background-size: 100% 100%;
  width: 21px;
  height: 21px;
}
.common-section2-item::after {
  position: absolute;
  top: 16px;
  left: 5px;
  content: " ";
  background: #f43814;
  width: 12px;
  height: 12px;
  border-radius: 10px;
}
.section-img {
  width: 598px;
  height: 375px;
}
.section-text {
  width: 100%;
  height: 40px;
  color: #fff;
  position: absolute;
  left:0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  line-height: 40px;
  font-size: 20px;
  box-sizing: border-box;
  padding:0 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.index-section-new-right /deep/ .swiper-pagination-bullet-active {
  background: #fe5022;
}
.section3 {
  width: 100%;
  height: 550px;
  background: url(/static/img/video_bg.png);
  background-size: 2560px 550px;
  margin: 43px 0;
  padding: 46px 0 56px 0;
  box-sizing: border-box;
}
.section3-cener {
  width: 1240px;
  margin: 0 auto;
  display: flex;
}
.section3-cener-left .swiper-container {
  width: 620px;
  height: 448px;
}
.section3-cener-right {
  flex: 1;
  width: 620px;
  padding: 0 30px;
  box-sizing: border-box;
}
.section3-cener-right-title {
  width: 100%;
  height: 70px;
  font-size: 30px;
  border-radius: 35px;
  text-align: center;
  line-height: 70px;
  color: #ffffff;
  background: #085ccb;
  font-weight: 600;
}
.section2-img {
  width: 620px;
  height: 448px;
  object-fit: fill;
}
.sw-wrapper {
  position: relative;
  background: rgba(0, 0, 0, 0.5);
}
.section3-text {
  width: 100%;
  height: 70px;
  color: #fff;
  font-size: 18px;
  background: rgba(0, 50, 110, 0.5);
  position: absolute;
  bottom: 0;
  left: 0;
  line-height: 70px;
  padding-left: 80px;
  padding-right: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 1000;
}
.section3-text::after {
  position: absolute;
  width: 70px;
  height: 70px;
  top: 0;
  left: 0;
  content: "重要活动";
  background: #085ccb;
  padding: 9px 11px;
  box-sizing: border-box;
  font-size: 20px;
  line-height: 25px;
  text-align: center;
  white-space: normal;
  letter-spacing: 4px;
}
.section3-list {
  margin-top: 40px;
}
.section3-list li {
  width: 100%;
  line-height: 46px;
  font-size: 16px;
  color: #2a2a2a;
  cursor: pointer;
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.section3-list .section3-list-content{
	width:70%;
	text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.section3-list span{
	font-size: 14px;

}
.top-section3-item::after {
  position: absolute;
  top: 12px;
  left: 0;
  content: "";
  background: url(/static/img/newicon2.png) no-repeat center;
  background-size: 100% 100%;
  width: 21px;
  height: 21px;
}
.common-section3-item::after {
  position: absolute;
  top: 16px;
  left: 5px;
  content: " ";
  background: #085ccb;
  width: 12px;
  height: 12px;
  border-radius: 10px;
}
.play-btn {
  position: absolute;
  width: 101px;
  height: 101px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.play-btn::after {
  content: "";
  position: absolute;
  width: 35px;
  height: 38px;
  top: 50%;
  left: 54%;
  transform: translate(-50%, -50%);
  background: url("/static/img/play.png") no-repeat center center;
  background-size: 35px 38px;
}
.play-full-puse {
  position: absolute;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  height: 60px;
  bottom: 0px;
  display: flex;
  justify-content: space-between;
  background: rgba(0, 50, 110, 0.5);
  color: #fff;
}
.control {
  position: absolute;
  bottom: 10px;
  left: 0px;
  width: 100%;
  height: 6px;
  border-radius: 2px;
  background: #fff;
}

#progress {
  width: 0px;

  height: 6px;

  border-radius: 5px 5px;

  position: absolute;

  left: 0;

  top: 0;

  background: red;
}

#scroll {
  width: 20px;

  height: 10px;

  border-radius: 5px 5px;

  -webkit-border-radius: 5px 5px;

  -moz-border-radius: 5px 5px;

  -o-border-radius: 5px 5px;

  position: absolute;

  top: -2px;

  left: 0;

  background: gray;
}

.play-full-puse .iconfont {
  font-size: 24px;
  line-height: 40px;
  cursor: pointer;
}
/* :-webkit-full-screen {
    background-color: black;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
} */
.section3-cener-left /deep/ .swiper-pagination-bullet {
  width: 23px !important;
  height: 23px !important;
  font-size: 12px;
  text-align: center;
  line-height: 23px;
  border-radius: 50%;
  display: inline-block;
  background: #fff;
  opacity: 1 !important;
  color: #333;
  margin: 0 3px;
}
.section3-cener-left /deep/ .swiper-pagination-bullet-active {
  background: #fff;
  color: #1a3783;
  font-size: 12px;
  border: 2px solid #1a3783;
  opacity: 1 !important;
}
.section3-cener-left
  /deep/
  .swiper-container-horizontal
  > .swiper-pagination-bullets,
.section3-cener-left /deep/ .swiper-pagination-custom,
.section3-cener-left /deep/ .swiper-pagination-fraction {
  bottom: 25px;
}
.section3-cener-left /deep/ .swiper-pagination {
  width: auto;
  display: table;
  text-align: right;
  box-sizing: border-box;
  left: unset;
  right: 23px !important;
  left: none;
}
.section4 {
  width: 100%;
  border-bottom: 1px solid #d5dce6;
  padding: 30px 0 80px;
  box-sizing: border-box;
  background: #fff;
}
.section4-img-wrapper > img {
  display: block;
  margin: 0 auto 23px;
}
.section4-line {
  width: 120px;
  height: 8px;
  background: rgba(8, 92, 203, 1);
  margin: 0 auto 38px;
}
.section4-center {
  width: 1240px;
  height: 100%;
  margin: 0 auto;
}
.section4-center-item {
  /* flex: 1; */
 display: block;
  width: 221px;
  height: 364px;
  position: relative;
  transition: all 0.5s;
  top: 0;
  cursor: pointer;
  float: left;
  margin-right: 33px;
  box-shadow: 0 0 25px rgba(195, 205, 224, 1);
  border-radius: 10px;
}
.section4-center-item:nth-child(5) {
  margin-right: 0 !important;
}

.section4-center-item:hover {
  top: -10px;
}
.section4-center-item-text {
  position: absolute;
  box-sizing: border-box;
  left: 40px;
  right: 40px;
  bottom: 5px;
  height: 50px;
  text-align: center;
  font-size: 14px;
  color: rgba(1, 41, 104, 1);
  line-height: 20px;
  overflow: hidden;
}
.section4-center-item1 {
  background: url(/static/img/big-icon1.png) no-repeat center center;
  background-size: 221px 364px;
}
.section4-center-item2 {
  background: url(/static/img/big-icon2.png) no-repeat center center;
  background-size: 221px 364px;
}
.section4-center-item3 {
  background: url(/static/img/big-icon3.png) no-repeat center center;
  background-size: 221px 364px;
}
.section4-center-item4 {
  background: url(/static/img/big-icon4.png) no-repeat center center;
  background-size: 221px 364px;
}
.section4-center-item5{
  background: url(/static/img/big-icon5.png) no-repeat center center;
  background-size: 221px 364px;
}

.section4-new{
  width: 1240px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 auto;
}
.section4-new .list{
  width: 250px;
  height: 250px;
  background: #F2F6FC;
  margin-bottom: 50px;
  position: relative;
}
.section4-new .list a{
  width: 100%;
  height: 100%;
  display: block;
}
.section4-new .list .listImg{
  width: 75px;
  height: 60px;
  background: url(../../../../static/img/8.1.png) no-repeat center;
  background-size: 100% 100%;
  margin: 20px auto;
}
.section4-new .list .title{
  font-size: 20px;
  color: #000;
  text-align: center;
  margin-bottom: 20px;
  line-height: 22px;
}
.section4-new .list .tip{
  font-size: 14px;
  line-height: 20px;
  color: #666666; 
  text-align: center;
}
.section4-new .list .look{
  width: 80px;
  height: 30px;
  background: #045DCE;
  color: #fff;
  font-size: 14px;
  display: block;
  text-align: center;
  line-height: 30px;
  border-radius: 5px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 20px;
}
.section4-new .list:hover .look{
  background: #fff;
  color: #045DCE;
}
.section4-new .list:hover{
  background: url(../../../../static/img/9.png) no-repeat center;
  background-size: 100% 100%;
}
.section4-new .list:hover .title,.section4-new .list:hover .tip{
  color: #fff;
}
.section4-new .list:first-child:hover .listImg{
  background: url(../../../../static/img/3.png) no-repeat center;
  background-size: 100% 100%;
}
.section4-new .list:nth-child(2) .listImg{
  width: 75px;
  height: 60px;
  background: url(../../../../static/img/1.1.png) no-repeat center;
  background-size: 100% 100%;
  margin: 20px auto;
}
.section4-new .list:nth-child(2):hover .listImg{
  background: url(../../../../static/img/8.png) no-repeat center;
  background-size: 100% 100%;
}

.section4-new .list:nth-child(3) .listImg{
  width: 75px;
  height: 60px;
  background: url(../../../../static/img/2.1.png) no-repeat center;
  background-size: 100% 100%;
  margin: 20px auto;
}
.section4-new .list:nth-child(3):hover .listImg{
  background: url(../../../../static/img/7.png) no-repeat center;
  background-size: 100% 100%;
}

.section4-new .list:nth-child(4) .listImg{
  width: 75px;
  height: 60px;
  background: url(../../../../static/img/3.1.png) no-repeat center;
  background-size: 100% 100%;
  margin: 20px auto;
}
.section4-new .list:nth-child(4):hover .listImg{
  background: url(../../../../static/img/6.png) no-repeat center;
  background-size: 100% 100%;
}
.section4-new .list:nth-child(5) .listImg{
  width: 75px;
  height: 60px;
  background: url(../../../../static/img/4.1.png) no-repeat center;
  background-size: 100% 100%;
  margin: 20px auto;
}
.section4-new .list:nth-child(5):hover .listImg{
  background: url(../../../../static/img/5.png) no-repeat center;
  background-size: 100% 100%;
}
.section4-new .list:nth-child(6) .listImg{
  width: 75px;
  height: 60px;
  background: url(../../../../static/img/5.1.png) no-repeat center;
  background-size: 100% 100%;
  margin: 20px auto;
}
.section4-new .list:nth-child(6):hover .listImg{
  background: url(../../../../static/img/4.png) no-repeat center;
  background-size: 100% 100%;
}
.section4-new .list:nth-child(7) .listImg{
  width: 75px;
  height: 60px;
  background: url(../../../../static/img/6.1.png) no-repeat center;
  background-size: 100% 100%;
  margin: 20px auto;
}
.section4-new .list:nth-child(7):hover .listImg{
  background: url(../../../../static/img/2.png) no-repeat center;
  background-size: 100% 100%;
}
.section4-new .list:nth-child(8) .listImg{
  width: 75px;
  height: 60px;
  background: url(../../../../static/img/7.1.png) no-repeat center;
  background-size: 100% 100%;
  margin: 20px auto;
}
.section4-new .list:nth-child(8):hover .listImg{
  background: url(../../../../static/img/1.png) no-repeat center;
  background-size: 100% 100%;
}
.section5 {
  width: 1300px;
  margin: 0 auto;
  padding: 31px 40px 0 0;
  box-sizing: border-box;
  display: flex;
}

.section5-img {
  width: 451px;
  height: 272px;
}
.secton5-right {
  flex: 1;
  padding: 30px 0;
  box-sizing: border-box;
}
.section5-right-top {
  width: 809px;
  height: 50px;
  background: url(/static/img/link-line.png) no-repeat center center;
  background-size: 100% 100%;
}
.section5-top-text {
  font-size: 0px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  overflow: hidden;
  height: 50px;
  padding: 10px;
  box-sizing: border-box;
}
.link-icon {
  display: inline-block;
  width: 21px;
  height: 27px;
  vertical-align: middle;
  margin: 0 5px;
}
.link-text {
  font-size: 20px;
  line-height: 20px;
  display: inline-block;
  vertical-align: middle;
}
.section5-shadow {
  box-shadow: 0 0 10px #dfdfdf;
}
.section5-select {
  width: 100%;
  background: #fff;
}
.section5-select {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 0 30px 25px;
  box-sizing: border-box;
}

.select-item {
  width: 300px;
  height: 40px;
  line-height: 40px;
  margin-top: 25px;
  position: relative;
}
.select-item select {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
}
.select-item select::-ms-expand {
  display: none;
}
.select-item select {
  width: 100%;
  height: 40px;
  line-height: 40px;
  border: none;
  outline: none;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0 36px 0 10px;
  color: #000;
  font-size: 18px;
}
.icon-down {
  position: absolute;
  top: 8px;
  right: 8px;
  display: block;
  width: 15px;
  height: 24px;
  background-size: 15px 24px;
  background: url("/static/img/select.png") no-repeat center;
}
.video-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1002;
}
.fixed-video-width {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 800px;
}
.close-video {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.7);
  /* background: url(/static/img/close.png) no-repeat center center;
    background-size: 37px 35px; */
  z-index: 1003;
}
.close-video > img {
  width: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/views/Index/index.vue